module.exports = __webpack_public_path__ + "empty-state-avatar-activities.svg?171e0df4bfa47999c03ed48ad2f6c6cc";